"use client";

import clsx from "clsx";
import RichText from "./Locality/LocalityRichText";
import { useLocalityService } from '@/providers/Locality';
import LocalityMoreInfoButton from "./Locality/LocalityMoreInfoButton";
import { MultiProductBlock } from "@/payload-types";

type ItemFromMultiProduct = NonNullable<MultiProductBlock["products"]>[number];

export default function ServiceTitle({
  data,
  className,
}: {
  data: ItemFromMultiProduct;
  className?: string;
}) {
  const localityService = useLocalityService();

  return (
    <div className={clsx("", className)}>
      <div className="flex items-center justify-between xsmall:flex-col md:flex-row">
        {data.title && (
          <h2 className="max-w-3xl font-bold tracking-tight text-gray-900 sm:text-2xl md:text-3xl">
            {localityService.replaceTags(data.title)}
          </h2>
        )}
        <LocalityMoreInfoButton callToAction={data.link} className="" />
      </div>
      {data.richText && (
        <div className="mt-4 max-w-3xl text-gray-500">
          <RichText data={data.richText} />
        </div>
      )}
    </div>
  );
}
